<template>
	<form @submit.prevent="submit" class="omapi-search flex">
		<input
			type="search"
			class="omapi-input omapi-input__inline"
			v-model="internalSearchTerm"
			@keydown.esc="clear"
			@search="submit"
		/>
		<svg-times
			class="clear-search"
			v-if="internalSearchTerm"
			@click="clear"
		/>
		<core-button buttonType="submit" size="large">Search</core-button>
	</form>
</template>

<script>
export default {
	props : {
		searchTerm : String,
	},
	data () {
		return {
			internalSearchTerm : this.searchTerm,
		}
	},
	watch : {
		searchTerm (val) {
			this.internalSearchTerm = val
		},
	},
	methods : {
		clear () {
			this.internalSearchTerm = ''
			this.submit()
		},
		submit () {
			this.$emit('searched', this.internalSearchTerm)
		},
	},
}
</script>
